import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVoterAuth } from '../contexts/VoterAuthContext';
import client from '../api/client';

export default function VoterLogin() {
  const [nationalId, setNationalId] = useState('');
  const [password, setPassword] = useState('');
  const [challenge, setChallenge] = useState('');
  const [otp, setOtp] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const { login } = useVoterAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = challenge
        ? await client.post('/auth/voter/otp', { challenge, code: otp })
        : await client.post('/auth/voter/login', { national_id: nationalId, password });
      if (res.data.otp_required) { setChallenge(res.data.challenge); setPassword(''); return; }
      login(res.data.token, res.data.voter);
      navigate('/vote/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
      setOtp('');
    } finally { setBusy(false); }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Voter Login</h1>
        <p>{challenge ? "Enter the current six-digit code from your authenticator." : "Enter your National ID and password to access the voting portal."}</p>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={handleSubmit}>
          {!challenge && <>
          <div className="form-group">
            <label htmlFor="national-id">National ID</label>
            <input
              id="national-id" type="text"
              value={nationalId}
              onChange={e => setNationalId(e.target.value)}
              placeholder="e.g. VOTER001"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="voter-password">Password</label>
            <input
              id="voter-password" type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>
          </>}
          {challenge && <div className="form-group">
            <label htmlFor="authenticator-code">Authenticator code</label>
            <input id="authenticator-code" type="text" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} value={otp} onChange={e => setOtp(e.target.value.replace(/[^0-9]/g, ''))} required autoFocus />
          </div>}
          <button type="submit" className="btn-primary" disabled={busy}>{busy ? 'Signing in...' : challenge ? 'Verify and login' : 'Login'}</button>
          {challenge && <button type="button" className="btn-secondary" onClick={() => { setChallenge(''); setOtp(''); setError(''); }}>Start again</button>}
        </form>
      </div>
    </div>
  );
}
